<template>
	<div>
		<b-form @submit.prevent="onSubmit">
			<div class="sa-form-section sa-search-box">
				<slot filter />
				<b-row style="margin-top: 5px">
					<b-col class="sa-padding-right text-right mb-3">
						<b-button type="submit" variant="info">{{ this.$i18n.t("global.lblFind") }}</b-button>
						<b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
					</b-col>
				</b-row>
			</div>
		</b-form>
	</div>
</template>

<script>
export default {
	methods: {
		onSubmit() {
			this.$emit("submit");
		},
		onReset() {
			this.$emit("reset");
		},
	},
};
</script>

<style></style>
